import { Orientation } from '@modules/src/enums/Orientation'
import { ModulesFacade } from '@modules/src/ModulesFacade'
import Facade from '../../Facade'

export const getCurrentOrientation = (): Orientation => {
    return (ModulesFacade.orientation || Facade.orientation || Orientation.LANDSCAPE) as Orientation
}
